import { render } from "./AccommodationHeader.vue?vue&type=template&id=0378ed6a&scoped=true"
import script from "./AccommodationHeader.vue?vue&type=script&lang=js"
export * from "./AccommodationHeader.vue?vue&type=script&lang=js"

import "./AccommodationHeader.vue?vue&type=style&index=0&id=0378ed6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0378ed6a"]])

export default __exports__